import { zodResolver } from '@hookform/resolvers/zod';
import { FC, PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { z } from 'zod';
import { getWorkflow, getWorkflowType } from 'modules/workflows/ducks';
import { publishedJourneyOptionsSchema } from 'modules/journey/components/PublishedJourneyOptions/publishedJourneyOptions.schema';
import { VISITOR_TRACKING_FIELD } from 'modules/journey/components/PublishedJourneyOptions/publishedJourneyOptions.constants';
import { useJourneyVisitorTrackingContext } from 'modules/workflows/context/JourneyVisitorTrackingContext';

const schema = publishedJourneyOptionsSchema;

export type PublishedJourneyFormSchemaType = z.infer<typeof schema>;

export const PublishJourneyFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const workflow = useSelector(getWorkflow);
  const { currentJourneyEligibility } = useJourneyVisitorTrackingContext();

  const { isJourneyEligible } = currentJourneyEligibility;
  const { draftOnly } = useSelector(getWorkflowType);
  const journeyReferenceVisitorTrackingEnabled =
    workflow?.workflowReference?.visitorTrackingEnabled;
  const currentJourneyVisitorTrackingEnabled = workflow?.visitorTrackingEnabled;

  const visitorTrackingEnabled =
    !draftOnly && isJourneyEligible
      ? journeyReferenceVisitorTrackingEnabled
      : currentJourneyVisitorTrackingEnabled;

  const methods = useForm<PublishedJourneyFormSchemaType>({
    defaultValues: {
      [VISITOR_TRACKING_FIELD]: visitorTrackingEnabled,
    },
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    methods.reset({
      [VISITOR_TRACKING_FIELD]: visitorTrackingEnabled,
    });
  }, [visitorTrackingEnabled]);

  return <FormProvider {...methods}>{children} </FormProvider>;
};
